import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { LinkText } from 'shared/Link';
import { paths } from 'client/shared/Paths';
import { ButtonPrimary } from '@spotify-internal/encore-web';

const MUSIC_NOT_ALLOWED_ERROR_TITLE = 'Unable to publish';
const MUSIC_NOT_ALLOWED_ERROR_BUTTON_LABEL = 'Got it';

type MusicNotAllowedErrorModalProps = {
  onDismiss: () => void;
};

export function MusicNotAllowedErrorModal({
  onDismiss,
}: MusicNotAllowedErrorModalProps): React.ReactElement {
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={onDismiss}
      aria-labelledby="music-not-allowed-error-modal-title"
    >
      <Modal.Title id="music-not-allowed-error-modal-title">
        {MUSIC_NOT_ALLOWED_ERROR_TITLE}
      </Modal.Title>
      <Modal.Body>
        <div>
          {`We’re having trouble publishing your episode. For more information reach out to us at `}
          <LinkText isInline target="_blank" to={paths.getHelpPage('home')}>
            {paths.getHelpPage('home')}
          </LinkText>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary onClick={onDismiss}>
          {MUSIC_NOT_ALLOWED_ERROR_BUTTON_LABEL}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
